import { makeStyles } from '@material-ui/styles'
import { ChevronRightRounded } from '@mui/icons-material'
import { Breadcrumbs, Button, ButtonBase, Divider, Link, List, ListItemButton, ListSubheader, Stack, Typography } from '@mui/material'
import { blue, grey } from '@mui/material/colors'
import { MouseEventHandler, ReactNode, useContext, useState } from 'react'
import { BsFileEarmarkArrowUp, BsPlusCircleDotted } from 'react-icons/bs'
import { IoEllipsisVertical, IoReloadOutline } from 'react-icons/io5'
import { useSelector } from 'react-redux'
import { Link as RouterLink, useParams } from 'react-router-dom'
import { AdminModalContext } from '../../../../../contexts/AdminModalContexts'
import pubsub from '../../../../../modules/pubsub'
import { selectCurrrentAdminShop } from '../../../../../store/features/currentBusinessShop'
import { CustomMenu } from '../../../../molecules'


export default function Header({onBtnPrimaryClick, onBtnSecondaryClick}:{onBtnPrimaryClick: ()=>void, onBtnSecondaryClick:()=>void}) {

    const {setCurrentModal} = useContext(AdminModalContext)
    const classes = useStyles()
    const currentShop = useSelector(selectCurrrentAdminShop)
    const {inventoryID} = useParams<{inventoryID: string}>()

    const handleOnReload = ()=>pubsub.trigger("inventory:changed")

    return(

        <Stack direction="row" justifyContent="space-between" alignItems="center" >
                
            <Stack direction="column">
                <Typography variant="h6" sx={{color: "grey.200", fontWeight: "bold" }}>Inventory</Typography>
                <Breadcrumbs sx={{color: grey[500] }} separator={<ChevronRightRounded sx={{color: grey[500]}} />}  >
                    <Link to={`/${currentShop?.name}`} className={classes.links} component={RouterLink} >
                        {currentShop?.name}
                    </Link>
                    <Link to="" className={classes.link_current} component={RouterLink} >
                        <span className="capitalize">
                            {inventoryID?.replaceAll(":","").replaceAll("_", " ")}
                        </span>
                    </Link>
                </Breadcrumbs>
            </Stack>

            <Stack direction="row" spacing={2}>
                <Button onClick={onBtnPrimaryClick} className={classes.button__primary} variant="contained" title="Add new products to inventory" startIcon={<BsPlusCircleDotted />} >
                    Add
                </Button>
                <Button onClick={onBtnSecondaryClick} className={classes.button__secondary} variant="contained" title="Export products to excel sheet" startIcon={<BsFileEarmarkArrowUp />} >
                    Export
                </Button>
                {/* <div className="border rounded border-white/60 bg-white/10 overflow-hidden">
                    <ButtonBase onClick={handleOnReload} sx={{width:"100%", height: "100%"}}>
                        <IoReloadOutline className='m-2' color='#fff' height={"1rem"} width={"1rem"} />
                    </ButtonBase>
                </div> */}
                <ContextMenu
                    header={<span>More</span>}
                    menuChildren={[
                        {item: <Stack direction="row" spacing={1}><BsPlusCircleDotted /> <span>Create new storage</span></Stack>, onClick: ()=>setCurrentModal("create_inventory")},
                        {item: <Stack direction="row" spacing={1}><IoReloadOutline /> <span>Reload</span></Stack>, onClick: handleOnReload},
                    ]}
                >
                    <div className="border rounded border-white/60 bg-white/10 overflow-hidden">
                        <ButtonBase onClick={handleOnReload} sx={{width:"100%", height: "100%"}}>
                            <IoEllipsisVertical className='m-2' color='#fff' height={"1rem"} width={"1rem"} />
                        </ButtonBase>
                    </div>
                </ContextMenu>
                
            </Stack>
        </Stack>

    )
}

const useStyles= makeStyles(theme=>({

    button__primary:{
        color: grey[200],
        boxShadow: "none",
        backgroundColor: blue[700],
        textTransform: "capitalize",
        '&:hover': {
            backgroundColor: blue[700]
        },
        border: `.5px solid rgba(255, 255, 255, 0.1)`,
    },
    button__secondary:{
        color: '#1A1B41',
        boxShadow: "none",
        backgroundColor: '#baff29',
        textTransform: "capitalize",
        '&:hover': {
            backgroundColor: '#baff29'
        },
        border: `.5px solid rgba(255, 255, 255, 0.1)`,
    },
    links:{
        color: grey[200],
        textDecoration: "none",
        fontSize: "13px"
    },
    link_current:{
        color: grey[500],
        textDecoration: "none",
        fontSize: "13px"
    }

}))

interface ContextMenuProps{
    header: ReactNode, 
    menuChildren: {
        onClick: (arg?:any)=>void
        item: ReactNode
    }[], 
    children:ReactNode
}


const ContextMenu = ({header, menuChildren, children}: ContextMenuProps)=>{

    const [contextMenuAnchorEl, setContextMenuAnchorEl] = useState<HTMLButtonElement|null>(null)
    const contextMenuIsOpen = Boolean(contextMenuAnchorEl)

    const handleContextMenuOnClose = ()=>setContextMenuAnchorEl(null)
    const handleOnContextMenuClick:MouseEventHandler<HTMLButtonElement> = (e)=>setContextMenuAnchorEl(e.currentTarget)


    return(
        <>
            <Stack>
                <ButtonBase
                    onClick={handleOnContextMenuClick}
                >
                    {children}
                </ButtonBase>
            </Stack>
            <CustomMenu
                open={contextMenuIsOpen}
                anchorEl={contextMenuAnchorEl}
                onClose={handleContextMenuOnClose}
            >
                <List
                    subheader={
                        <ListSubheader 
                            sx={{backgroundColor: "primary.dark", color: "grey.200"}}
                        >
                            <h5 className="">{header}</h5>
                        </ListSubheader>
                    }
                >
                    {
                        menuChildren.map((dta, idx)=>(
                            <>
                                <ListItemButton
                                    key={`${header}_contx_menu_lisItm_${idx}`}
                                    onClick={dta.onClick}
                                >
                                    {dta.item}
                                </ListItemButton>
                                {idx !== menuChildren.length-1 && <Divider />}
                            </>
                        ))
                    }
                </List>
            </CustomMenu>
        </>
        
    )
    
}